import { LoadingSpinner } from "./LoadingSpinner";

interface AppLoadingStateProps {
  title?: string;
  subtitle?: string;
  showProgress?: boolean;
}

export function AppLoadingState({
  title = "Loading your organization...",
  subtitle = "Setting up your workspace",
  showProgress = false,
}: AppLoadingStateProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center flex flex-col items-center justify-center max-w-md mx-auto px-6">
        {/* Logo or Brand Area */}
        <div className="mb-8">
          <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-4">
            <div className="w-8 h-8 bg-primary rounded-lg"></div>
          </div>
        </div>

        {/* Loading Spinner */}
        <div className="mb-6">
          <LoadingSpinner size="lg" className="w-10 h-10" />
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-text-primary mb-2">
          {title}
        </h2>

        {/* Subtitle */}
        <p className="text-text-secondary text-sm mb-6">{subtitle}</p>

        {/* Progress Bar (optional) */}
        {showProgress && (
          <div className="w-full max-w-xs">
            <div className="h-1 bg-background-tertiary rounded-full overflow-hidden">
              <div className="h-full bg-primary rounded-full animate-pulse w-2/3"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
